import React from 'react';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            headline: 'The Rivalry Issue',
            leftLogo: this.props.leftLogo,
            rightLogo: this.props.rightLogo,
            donateUrl: this.props.donateUrl,
        }
    }

    render() {
        return (
            <div className="header-image news-logo row">
                <div className="left-logo five columns">
                    <a href="https://www.michigandaily.com/">
                        <img className="left-logo" src={this.state.leftLogo} />
                    </a>
                </div>
                <div className="x two columns">x</div> 
                <div className="right-logo five columns">
                    <a href="https://www.thelantern.com/">
                        <img className="right-logo" src={ this.state.rightLogo } />
                    </a>
                </div>
                <div className="header-text row">
                    <div className="six columns">
                        <div className="large-header-text">
                            <div> THE</div>
                            <div className="bold-maize-text"> RIVALRY </div>
                            <div>ISSUE</div>
                        </div>
                        <div className="small-header-text">
                            THE FIRST-EVER COLLABORATION <br/> BETWEEN THE TWO STUDENT NEWSPAPERS
                        </div>
                        <div id="header-text-yellow">
                            SUPPORTING STUDENT JOURNALISM
                        </div>
                    </div>
                </div>
                
            </div>
        );
    }
        
    
}

export default Header;